import { makeStyles } from "@material-ui/core/styles";
import ShareIcon from "@material-ui/icons/Share";
import { Z_APPS_SHORT_URL } from "../../../../../../../common/consts";
import { DarkButton } from "../../../../../../shared/Button/DarkButton";

export function ShareButton({ userId }: { userId?: number }) {
    const c = useStyles();

    return (
        <DarkButton
            startIcon={<ShareIcon className={c.icon} />}
            className={c.button}
            onClick={async () => {
                if (!userId) {
                    return;
                }
                try {
                    await navigator.clipboard.writeText(
                        `${Z_APPS_SHORT_URL}/u/${userId}`
                    );
                    alert("Profile Link Copied");
                } catch (err) {
                    alert("Failed to copy");
                }
            }}
        >
            Share
        </DarkButton>
    );
}
const useStyles = makeStyles({
    button: {
        position: "absolute",
        top: 7,
        right: 7,
        maxHeight: 25,
        minHeight: 25,
        fontSize: "small !important",
        lineHeight: 1,
    },
    icon: { width: 15 },
});
